import { Children } from 'react';
import styled, { css } from 'styled-components';

const ITEM_HEIGHT = '62px';

interface ContainerPropsInterface {
  isShow: boolean;
}

export const Container = styled.div<ContainerPropsInterface>`
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.65, 0, 0.35, 1);

  ${({ children, isShow }) =>
    isShow &&
    css`
      max-height: calc(${Children.count(children)} * ${ITEM_HEIGHT});
      transition: all 0.3s cubic-bezier(0.65, 0, 0.35, 1);
    `}
`;
